import {
    type TimeFormat,
    createDate,
    createDateRange,
    format,
    formatDateHour,
} from '@lingoda/dates';
import { useSelector } from '@lingoda/hooks';
import { studentTimeFormatPreferenceSelector } from '@lingoda/students';
import { Box, Grid, Typography } from '@lingoda/ui';
import { ClockIcon } from '@lingoda/ui/icons/lingodaIcons';
import { capitalize } from '@lingoda/utils';

interface ClassTimeProps {
    startDateIso?: string;
    endDateIso?: string;
}

export const ClassTime = ({ startDateIso, endDateIso }: ClassTimeProps) => {
    const timeFormat = useSelector(studentTimeFormatPreferenceSelector);

    return (
        <Grid container item xs={12} marginTop={3}>
            <Box width={({ spacing }) => spacing(6)}>
                <ClockIcon size={24} />
            </Box>
            {startDateIso && (
                <Box width={({ spacing }) => `calc(100% - ${spacing(6)})`}>
                    <Typography variant="body1">
                        {capitalize(format('cccc, d MMMM yyyy', createDate(startDateIso)))}
                    </Typography>
                    {endDateIso && (
                        <Typography variant="body1">
                            {getClassTimeRange(startDateIso, endDateIso, timeFormat)}
                        </Typography>
                    )}
                </Box>
            )}
        </Grid>
    );
};

export const getClassTimeRange = (
    startDateIso: string,
    endDateIso: string,
    timeFormat: TimeFormat,
) => {
    const range = createDateRange(startDateIso, endDateIso, '(O)');

    return `${formatDateHour(range.startDate, timeFormat)} - ${formatDateHour(
        range.endDate,
        timeFormat,
    )} ${range.timezone}`;
};
